























































































































































































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import DoKoHtmlDialog from "./DoKoHtmlDialog.vue";
import DoKoBtn from "../controls/DoKoBtn.vue";
import DokoTricksOverview from "../widgets/DokoTricksOverview.vue";

import { Action, Getter, Mutation } from "vuex-class";
import { api as deskApi } from "../../store/modules/desk";
import { Dictionary } from "lodash";
import { ROUTE_NAMES } from "../../router/routenames";
import { GameState, FriendRef, GameResult } from "@dokogd/shared";

@Component({ components: { DoKoHtmlDialog, DoKoBtn, DokoTricksOverview } })
export default class DoKoDialogSpielergebnis extends Vue {
  nextDisabled = true;

  symbolIds = [
    "gewinner",
    "zweiter",
    "dritter",
    "verlierer",
    "verlierer",
    "verlierer",
  ];

  @Prop({
    type: String,
    default: null,
  })
  gameNo!: string | null;

  @Getter(deskApi.getters.getGameState, { namespace: deskApi.namespace })
  gameState!: GameState;

  @Getter(deskApi.getters.getMappedUsers, { namespace: deskApi.namespace })
  mappedUsers!: Dictionary<FriendRef>;

  @Getter(deskApi.getters.getGameResult, { namespace: deskApi.namespace })
  gameResult!: null | GameResult;

  @Getter(deskApi.getters.isLastGameInRound, { namespace: deskApi.namespace })
  isLastGameInRound!: boolean;

  @Getter(deskApi.getters.isGameLeader, { namespace: deskApi.namespace })
  isGameLeader!: boolean;

  @Action(deskApi.actions.nextGame, { namespace: deskApi.namespace })
  nextGame!: () => Promise<void>;

  endDesk(): void {
    console.log("endDesk");
  }

  @Mutation(deskApi.mutations.SWITCH_GAME, { namespace: deskApi.namespace })
  switchGame!: (inc: number) => void;

  @Mutation(deskApi.mutations.SELECT_GAME, { namespace: deskApi.namespace })
  selectGame!: (gameNo: number) => void;

  @Watch("gameNo", {
    immediate: true,
  })
  onGameNoChanged(newVal: string | null): void {
    console.log("onGameNoChanged", newVal);
    if (newVal !== null) {
      this.selectGame(parseInt(newVal, 10));
    }
  }

  sw(inc: number) {
    if (this.gameNo === null) {
      this.switchGame(inc);
    } else {
      this.$router.push({
        name: this.$route.name ?? ROUTE_NAMES.GAMERESULT,
        params: {
          deskId: this.$route.params.deskId,
          gameNo: String(parseInt(this.gameNo, 10) + inc),
        },
      });
    }
  }

  // SWITCH_GAME

  get winnerTitle() {
    console.log("winnerSide", this.gameResult?.winnerSide);
    return this.gameResult?.winnerSide === "reDouble"
      ? "Re hat gewonnen"
      : "Kontra hat gewonnen";
  }

  get additionalExtraPointLines() {
    const count = this.gameResult?.extraPoints.length ?? 0;

    return count <= 1 ? 0 : count - 1;
  }

  mounted() {
    setTimeout(() => {
      this.nextDisabled = false;
    }),
      15000;
  }

  closeDialog() {
    console.log("closeDialog", this.$route);
    this.$router.push({
      name: ROUTE_NAMES.DESK,
      params: {
        deskId: this.$route.params.deskId,
      },
    });
  }
}
